import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      {/* Error Icon */}
      <CancelIcon sx={{ fontSize: 80, color: "red", marginBottom: 2 }} />

      {/* Error Message */}
      <Typography variant="h5" sx={{ color: "red", fontWeight: "bold" }}>
        {t("PaymentFailed")}
      </Typography>

      {/* Try Again Button */}
      <Button
        variant="contained"
        sx={{
          marginTop: 3,
          backgroundColor: "#d32f2f",
          color: "white",
          padding: "10px 30px",
          fontSize: "16px",
          borderRadius: "8px",
        }}
        onClick={() => navigate("/:activityId/booking/payment")}
      >
        {t("TryAgain")}
      </Button>
    </Box>
  );
};

export default PaymentFailed;
